import Quill from 'quill'
import type { BlotSpec, Options } from 'quill-blot-formatter'
import BlotFormatter from 'quill-blot-formatter'

import CustomImageBlot from './CustomImageBlot'

// @ts-expect-error Ignore missing deep internal Scope/create typings from Quill's Parchment. The runtime class is safe.
Quill.register(CustomImageBlot, true)

function isTouchDevice() {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) || window.innerWidth <= 1024
  )
}

class CustomBlotFormatter extends BlotFormatter {
  quill: Quill

  scrollContainer?: HTMLElement

  onScroll: () => void

  onDocumentClick: (e: MouseEvent) => void

  constructor(quill: Quill, options: Options = {} as Options) {
    const defaultOptions = {
      ...options,
      align: {
        toolbar: {
          mainStyle: {
            display: 'none'
          }
        }
      }
    }
    super(quill, defaultOptions as unknown as Options)
    this.quill = quill

    this.onScroll = () => {
      this.update()
    }

    this.scrollContainer = quill.root
    this.scrollContainer.addEventListener('scroll', this.onScroll)

    this.onDocumentClick = (e: MouseEvent) => {
      if (!this.currentSpec) return
      const target = e.target as HTMLElement
      const { overlay } = this
      const selectedElement = (
        this.currentSpec as unknown as { target?: HTMLElement }
      )?.target as HTMLElement

      if (selectedElement?.contains(target) || overlay?.contains(target)) {
        return
      }

      this.hide()
    }

    document.addEventListener('mousedown', this.onDocumentClick)
  }

  update() {
    // Bulletproof: If the image is detached/re-rendered by Quill's MutationObserver, try to re-bind the new img tag
    if (this.currentSpec) {
      const imgSpec = this.currentSpec as unknown as { img?: HTMLElement }
      if (imgSpec.img && !imgSpec.img.isConnected) {
        const src = imgSpec.img.getAttribute('src')
        if (src) {
          const newImg = this.quill.root.querySelector(
            `img[src="${src}"]`
          ) as HTMLElement
          if (newImg) {
            imgSpec.img = newImg
          }
        }
      }
    }
    super.update()
  }

  show(spec: BlotSpec) {
    if (isTouchDevice()) return
    super.show(spec)
  }

  destroy() {
    this.scrollContainer?.removeEventListener('scroll', this.onScroll)
    document.removeEventListener('mousedown', this.onDocumentClick)
  }
}

export default CustomBlotFormatter
